import { createAction } from 'redux-actions';

export const checkIfNPSSurveyRequestedAction = createAction('CHECK_IF_NPS_REQUESTED');
export const postNPSSurveyResultAction = createAction('POST_NPS_RESULT');
export const postNPSSurveyResultSuccessAction = createAction('POST_NPS_RESULT_SUCCESS');
export const postNPSSurveyResultFailureAction = createAction('POST_NPS_RESULT_FAILURE');
